import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router/index'
import { auth } from '@/utils/auth'
import { supabase } from '@/utils/supabase/client'
import 'flowbite'
import './index.css'
import './styles/components.css' // Add global components styles
import pkg from '../package.json'

// Import ApexCharts
import VueApexCharts from 'vue3-apexcharts'
import apexchartsPlugin from './plugins/apexcharts'

// Import Vue Toastification
import Toast from 'vue-toastification'
import 'vue-toastification/dist/index.css'

import * as Sentry from '@sentry/vue'
import { BrowserTracing } from '@sentry/browser'

const app = createApp(App)
const pinia = createPinia()

// Configure Vue Toastification
const toastOptions = {
  position: 'top-right',
  timeout: 5000,
  closeOnClick: true,
  pauseOnFocusLoss: true,
  pauseOnHover: true,
  draggable: true,
  draggablePercent: 0.6,
  showCloseButtonOnHover: false,
  hideProgressBar: true,
  closeButton: 'button',
  icon: true,
  rtl: false
}

Sentry.init({
  app,
  dsn: 'https://87af9550dc3c5d8b4178d88cea299c70@o4508321822801920.ingest.us.sentry.io/4508576389464064',
  integrations: [
    new BrowserTracing({
      routingInstrumentation: Sentry.vueRouterInstrumentation(router),
      tracingOrigins: ['localhost', /^\//]
    })
  ],
  // Set tracesSampleRate to 1.0 to capture 100% of transactions for performance monitoring
  tracesSampleRate: 1.0,
  // Enable release tracking
  release: `${pkg.name}@${pkg.version}`,
  // Environment configuration
  environment: import.meta.env.MODE,
  // Enable Vue error handling
  trackComponents: true,
  logErrors: true,
  attachProps: true,
  attachStacktrace: true,
  // Session tracking
  autoSessionTracking: true
})

app.use(Toast, toastOptions)
app.use(router)
app.use(pinia)
app.use(apexchartsPlugin)
app.mount('#app')

// Set up auth state change listener
supabase.auth.onAuthStateChange(async (event, session) => {
  if (event === 'SIGNED_IN') {
    auth.setSession(session)
  } else if (event === 'SIGNED_OUT') {
    auth.clearSession()
  }
})
